// extracted by mini-css-extract-plugin
export default {"skillsContainer":"skills_skillsContainer__XFkSM","skill":"skills_skill__Gq81z"};